import { Microscope } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const DataScienceIcon = createLucideIcon(Microscope);
